import { apiFetch } from '@ami/react/core';

export class PriceZoneSummary {
  constructor(json) {
    this.id = json.id;
    this.label = json.name || json.label;
    this.description = json.description;
    this.isoCurrencySymbol = json.isoCurrencySymbol;
    this.supportsInstallation = json.supportsInstallation;
    this.isProminent = json.isProminent;
  }
}

export class PriceZone {
  static async search() {
    return await apiFetch('price-zones');
  }

  static async summarySearch() {
    const result = await apiFetch('price-zones-summary');
    return result.map((x) => new PriceZoneSummary(x));
  }
}
